import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MasterConfig, MasterConfigParams } from '../../interfaces/master-config.interface';
import { ApiResponse } from '../../interfaces/ApiResponse';
import { PageResponse } from '../../interfaces/page-response.interface';
import { environment } from '../../../../environments/environment.dev';
import { CommonSearchParam, convertToHttpParams } from '../../interfaces/common-search-param.interface';
import { MasterConfigService } from './master-config.service';

@Injectable({
  providedIn: 'root'
})
export class MasterConfigApiService extends MasterConfigService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}v1/config-master`;

  constructor() {
    super();
  }

  getConfigMaster(params: MasterConfigParams): Observable<PageResponse<MasterConfig>> {
    const httpParams = convertToHttpParams(params);
    return this.wrapRequest(
      this.http.get<ApiResponse<PageResponse<MasterConfig>>>(this.baseUrl, {
        headers: this.headers,
        params: httpParams
      }).pipe(
        map(res => res?.response)
      )
    );
  }

  override findAll(commonSearchParam: CommonSearchParam): Observable<PageResponse<MasterConfig>> {
    return this.getConfigMaster({
      page: commonSearchParam.page,
      size: commonSearchParam.size,
      category: 'teamsize',
      searchTerm: commonSearchParam.searchTerm
    });
  }

  override find(id: string): Observable<MasterConfig> {
    return this.wrapRequest(
      this.http.get<ApiResponse<MasterConfig>>(`${this.baseUrl}/${id}`, {
        headers: this.headers
      }).pipe(map(res => res?.response))
    );
  }

  override create(data: Partial<MasterConfig>): Observable<MasterConfig> {
    return this.wrapRequest(
      this.http.post<ApiResponse<MasterConfig>>(this.baseUrl, data, {
        headers: this.headers
      }).pipe(map(res => res?.response))
    );
  }

  override update(id: string, data: Partial<MasterConfig>): Observable<MasterConfig> {
    return this.wrapRequest(
      this.http.put<ApiResponse<MasterConfig>>(`${this.baseUrl}/${id}`, data, {
        headers: this.headers,
      }).pipe(map(res => res?.response))
    );
  }

  override delete(id: string): Observable<void> {
    return this.wrapRequest(
      this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`, {
        headers: this.headers
      }).pipe(map(() => undefined))
    );
  }
}
